import config from "../_config/config";
import { authHeader } from "../_helpers";
import axios from "axios";

axios.defaults.baseURL = config.apiUrl;
axios.defaults.headers.post["Content-Type"] = "application/json";
axios.defaults.headers.post["X-Requested-With"] = "XMLHttpRequest";
axios.defaults.headers.put["Content-Type"] = "application/json";
axios.defaults.headers.put["X-Requested-With"] = "XMLHttpRequest";

export const checklistService = {
  // Default template - Control Room
  getAvailableTemplates,
  getTemplates,
  createTemplate,
  getTemplate,
  updateTemplate,
  deleteTemplate,
  adoptChecklistAsTemplate,

  // Checklist paziente - Company/operatore
  getPatientChecklists,
  createPatientChecklist,
  createChecklistFromTemplate,
  getPatientChecklist,
  updatePatientChecklist,
  deletePatientChecklist,
  addChecklistSection,
  updateChecklistSection,
  deleteChecklistSection,
  reorderChecklistSections,
  addChecklistItem,
  reorderChecklistItems,
  updateChecklistItem,
  deleteChecklistItem,
  completeChecklistItem,
  reopenChecklistItem,
};

// === DEFAULT TEMPLATE - CONTROL ROOM ===

function getAvailableTemplates(filters = {}) {
  var sett = { headers: authHeader(), params: filters };
  return axios
    .get("checklist-templates/available", sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}

function getTemplates(filters = {}) {
  var sett = { headers: authHeader(), params: filters };
  return axios
    .get("checklist-templates", sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}

function createTemplate(data) {
  var sett = { headers: authHeader() };
  return axios
    .post("checklist-templates", data, sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}

function getTemplate(templateId) {
  var sett = { headers: authHeader() };
  return axios
    .get(`checklist-templates/${templateId}`, sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}

function updateTemplate(templateId, data) {
  var sett = { headers: authHeader() };
  return axios
    .put(`checklist-templates/${templateId}`, data, sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}

function deleteTemplate(templateId) {
  var sett = { headers: authHeader() };
  return axios
    .delete(`checklist-templates/${templateId}`, sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}

// Adotta una checklist paziente come template di default (solo Control Room)
function adoptChecklistAsTemplate(checklistId, data) {
  var sett = { headers: authHeader() };
  return axios
    .post(
      `checklist-templates/from-patient-checklist/${checklistId}`,
      data,
      sett
    )
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}

// === CHECKLIST PAZIENTE - COMPANY/OPERATORE ===

function getPatientChecklists(filters = {}) {
  var sett = { headers: authHeader(), params: filters };
  return axios
    .get("companies/own/patient-checklists", sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}

function createPatientChecklist(data) {
  var sett = { headers: authHeader() };
  return axios
    .post("companies/own/patient-checklists", data, sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}

function createChecklistFromTemplate(data) {
  var sett = { headers: authHeader() };
  return axios
    .post("companies/own/patient-checklists/from-template", data, sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}

function getPatientChecklist(checklistId) {
  var sett = { headers: authHeader() };
  return axios
    .get(`companies/own/patient-checklists/${checklistId}`, sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}

function updatePatientChecklist(checklistId, data) {
  var sett = { headers: authHeader() };
  return axios
    .put(`companies/own/patient-checklists/${checklistId}`, data, sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}

function deletePatientChecklist(checklistId) {
  var sett = { headers: authHeader() };
  return axios
    .delete(`companies/own/patient-checklists/${checklistId}`, sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}

// Crea una nuova fase (sezione) nella checklist
function addChecklistSection(checklistId, data) {
  var sett = { headers: authHeader() };
  return axios
    .post(
      `companies/own/patient-checklists/${checklistId}/sections`,
      data,
      sett
    )
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}

function updateChecklistSection(sectionId, data) {
  var sett = { headers: authHeader() };
  return axios
    .put(`companies/own/patient-checklists/sections/${sectionId}`, data, sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}

function deleteChecklistSection(sectionId) {
  var sett = { headers: authHeader() };
  return axios
    .delete(`companies/own/patient-checklists/sections/${sectionId}`, sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}

function reorderChecklistSections(checklistId, orderedSections) {
  var sett = { headers: authHeader() };
  return axios
    .put(
      `companies/own/patient-checklists/${checklistId}/sections/reorder`,
      { sections: orderedSections },
      sett
    )
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}

function addChecklistItem(checklistId, data) {
  var sett = { headers: authHeader() };
  return axios
    .post(`companies/own/patient-checklists/${checklistId}/items`, data, sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}

function reorderChecklistItems(checklistId, orderedItems) {
  var sett = { headers: authHeader() };
  return axios
    .put(
      `companies/own/patient-checklists/${checklistId}/items/reorder`,
      { items: orderedItems },
      sett
    )
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}

function updateChecklistItem(itemId, data) {
  var sett = { headers: authHeader() };
  return axios
    .put(`companies/own/patient-checklists/items/${itemId}`, data, sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}

function deleteChecklistItem(itemId) {
  var sett = { headers: authHeader() };
  return axios
    .delete(`companies/own/patient-checklists/items/${itemId}`, sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}

function completeChecklistItem(itemId) {
  var sett = { headers: authHeader() };
  return axios
    .patch(
      `companies/own/patient-checklists/items/${itemId}/complete`,
      {},
      sett
    )
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}

function reopenChecklistItem(itemId) {
  var sett = { headers: authHeader() };
  return axios
    .patch(`companies/own/patient-checklists/items/${itemId}/reopen`, {}, sett)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((err) => {
      var error = err.response;
      return Promise.reject(error);
    });
}
